var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title_label_container d-flex text-align-center",class:{ 'justify-content-center' : _vm.centerAlign, 'is-title': _vm.isTitle, 'is-caption': _vm.isCaption }},[_c('h6',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e6461c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/sectionTitleAndLabel.vue
// module id = null
// module chunks = 